{
    "ReportlistMyreportlist": "Minha lista de relatórios",
    "ReportlistAddreport": "Adicionar relatório",
    "ReportlistDeletereport": "remover relatório",
    "ReportlistMoreoptions": "Mais opções",
    "ReportlistModifyreport": "Modificar relatório",
    "ReportlistCopyreport": "Copiar relatório",
    "ReportlistRenamefolder": "Renomear pasta",
    "ReportlistRenamereport": "Renomear relatório",
    "NoreportsconfiguredText": "Nenhum relatório configurado.",
    "ReportlistRecyclebin": "Reciclagem",
    "ReportlistEmptyrecyclebin": "Esvaziar Reciclagem",
    "ReportlistRestoreallreports": "Restaurar todos os relatórios",
    "ReportlistRestorereport": "Restaurar relatório",
    "ReportlistDeletereportsinfolder": "remover conteúdo da pasta",
    "ReportlistRestorereportsinfolder": "Restaurar conteúdo da pasta",
    "ReportlistNotAllCompleted": "{} de {} relatórios selecionados foram movidos para a Reciclagem.",
    "ReportlistOutof": "fora de",
    "ReportlistNoreportswererestored": "Nenhum relatório foi restaurado.",
    "ReportlistReportwasrestored": "O relatório foi restaurado.",
    "ReportlistReportswererestored": "{} relatórios foram restaurados.",
    "ReportlistXoutofyselectedreportswererestored": "{} de {} relatórios selecionados foram restaurados.",
    "ReportlistRestoregenericfailurereason": "Os relatórios com falha podem já ter sido restaurados ou removidos permanentemente.",
    "ReportlistNoreportsweremovedtobin": "Nenhum relatório foi movido para a Reciclagem.",
    "ReportlistReportwasmovedtobin": "O relatório foi movido para a Reciclagem.",
    "ReportlistReportsweremovedtobin": "{} relatórios foram movidos para a Reciclagem.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} de {} relatórios selecionados foram movidos para a Reciclagem.",
    "ReportlistMovetobingenericfailurereason": "Os relatórios com falha podem já ter sido movidos para o compartimento.",
    "ReportlistThirtydaysremaining": "Isso permanecerá em sua Reciclagem por 30 dias ou até ser esvaziado.",
    "ReportlistBeendeleted": "foi deletado.",
    "ReportlistNoreportsweredeletedpermanently": "Nenhum relatório foi removido permanentemente.",
    "ReportlistReportwasdeletedpermanently": "O relatório foi removido permanentemente.",
    "ReportlistReportsweredeletedpermanently": "{} relatórios foram removidos permanentemente.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} de {} relatórios selecionados foram removidos permanentemente.",
    "ReportlistDeletepermanentlygenericfailurereason": "Os relatórios com falha podem já ter sido removidos ou restaurados permanentemente e não estão mais na Reciclagem.",
    "ReportlistMoveToBinCondition": "No futuro, não me mostre esta caixa de diálogo.",
    "ReportlistNoreportswerecopied": "Nenhum relatório foi copiado.",
    "ReportlistReportwascopied": "O relatório foi copiado.",
    "ReportlistReportswerecopied": "{} relatórios foram copiados.",
    "ReportlistXoutofyselectedreportswerecopied": "{} de {} relatórios selecionados foram copiados.",
    "ReportlistCopygenericfailurereason": "Os relatórios com falha podem já ter sido movidos para o compartimento.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Adicionar relatório predefinido",
    "ReportListCopyReportsSuccessfulMessage": "Copiou com sucesso {} relatório(s)",
    "ReportlistOverrideExistingReport": "Assinale se pretende substituir os Relatórios existentes.",
    "ReportlistReportsKeptForThirtyDays": "Os relatórios anulados serão guardados na Reciclagem durante 30 dias ou até serem esvaziados."
}